import { render } from "./LogSOA.vue?vue&type=template&id=4d022f30"
import script from "./LogSOA.vue?vue&type=script&lang=js"
export * from "./LogSOA.vue?vue&type=script&lang=js"

import "./LogSOA.vue?vue&type=style&index=0&id=4d022f30&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__